module.exports = __webpack_public_path__ + "static/media/Group 6520.d0f4b779.svg";